/*
 * Special Module for handling the Topics and Topic pages, and switching between them without distroying each other
 * This module basically is just a wrapper for the Topics and Topic modules, but handles some functionality for
 * switching between them
 */

define([
  "marionette",
  "backbone",
  "jquery",
  "underscore",
  "configuration/properties",
  "messaging/messenger",
  "modules/reportSplit/reportSplitView",
  "modules/reportSplit/groups/groupModule",
  "modules/reportSplit/reports/reportsModule",
  "modules/reportSplit/adHoc/adHocReportModule",
  "modules/reportSplit/reports/singleReport/reportUtilities",
], function (
  Marionette,
  Backbone,
  $,
  _,
  Properties,
  Messenger,
  ReportSplitView,
  GroupsModule,
  ReportModule,
  AdHocReportModule,
  ReportUtilities,
) {
  "use strict";

  const ReportSplitController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "reportSplitModule";
      this.region = options.region;
      this._setUpVents();
      this.router = new Router({
        controller: this,
      });
    },
    show: function () {
      this.groupsLoaded = false; //true if we have shown the topics page before
      this.layout = new ReportSplitView.reportSplitLayout();
      this.groups = this.addSubModule(new GroupsModule({ region: this.layout.groupsRegion }));
      this.reportModule = this.addSubModule(new ReportModule({ region: this.layout.reportRegion }));
      this.adHocReportModule = this.addSubModule(
        new AdHocReportModule({ region: this.layout.adHocReportRegion }),
      );
      this.showRegion(this.layout);

      //temporary save code
      Messenger.onSave(function () {
        //don't save anything.
        console.log("reports onSave");
        Messenger.saveAttempted(true); //success
      }, this);
    },
    showReport: function (report, alsoDisplay) {
      //set URL
      //        var kbId = Messenger.reqres.request("active:kb");
      //        var reportUrl = report.get('href').substring(1);
      //        var slIndex = reportUrl.indexOf('/');
      //        if (slIndex !== -1)
      //          reportUrl = reportUrl.substring(0, slIndex);
      //        Backbone.history.navigate(kbId + "/report/" + reportUrl); //use the separate intentId to fill out URL

      document.title = $.t(report.name ? report.name : report.get("name"));
      document.title += " - " + Properties.applicationName;
      if (!this.isOpen) {
        //initialize region if we haven't done so already
        this.show();
      }
      //hide report group page and ad-hoc report
      this.layout.hideGroups();
      this.layout.hideAdHocReport();
      //unhide report page
      this.layout.showReportPage();
      //make sure main region is visible
      this.region.trigger("show");

      //toggle isOpen parameter
      this.groups.isOpen = false;
      //show topic page (always get a fresh page)
      //if (report.toJSON)
      //  reportModule = report.toJSON();
      this.reportModule.show(report);
      if (alsoDisplay) {
        this.reportModule.displayReport(report);
      }
    },
    showAdHocReport: function (url) {
      //hide report and group page
      this.layout.hideGroups();
      this.layout.hideReport();
      //show ad-hoc report page
      this.layout.showAdHocReport();
      //make sure main region is visible
      this.region.trigger("show");
      this.adHocReportModule.show(url);
    },
    displayReport: function (report) {
      console.log("displaying report " + report.href);
      report.useArgumentDefaults = true; //since we are coming from history
      this.reportModule.displayReport(report);
      //vent that it is finished displaying
      Messenger.vent.trigger("report:finished:displaying");
    },
    showGroups: function () {
      document.title = $.t("menuBar.reports") + " - " + Properties.applicationName;
      //set URL
      if (!this.isOpen) {
        this.show();
      }
      //hide the report and ad-hoc report page
      this.layout.hideReport();
      this.layout.hideAdHocReport();
      //unhide report groups page
      this.layout.showGroups();
      //make sure main region is visible
      this.region.trigger("show");

      this.reportModule.isOpen = false;
      if (!this.groupsLoaded) {
        //topics page hasn't been shown before, so create it and show it
        this.groups.show();
        this.groupsLoaded = true;
      } else {
        this.groups.isOpen = true; //toggle isOpen parameter
      }
      //otherwise, we get the existing version of topics we had hidden
    },
    _routeReports: function (kbId) {
      const isAuthor = Messenger.reqres.request("user:is:author", kbId);
      const isReporter = Messenger.reqres.request("user:is:reporter", kbId);
      if (!isAuthor && !isReporter) {
        Backbone.history.navigate("", { trigger: true });
        return;
      }
      Messenger.command.execute("set:active:kb", kbId);
      Messenger.command.execute("change:menu", "reports");
      this.showGroups();
    },
    _routeReportMain: function (kbId, reportHref) {
      if (reportHref === "adHoc") {
        //Navigate to the parent reports page if trying to access adHoc reports
        Backbone.history.navigate(kbId + "/reports", { trigger: true });
        return;
      }
      const isAuthor = Messenger.reqres.request("user:is:author", kbId);
      const isReporter = Messenger.reqres.request("user:is:reporter", kbId);
      if (!isAuthor && !isReporter) {
        Backbone.history.navigate("", { trigger: true });
        return;
      }
      Messenger.command.execute("set:active:kb", kbId);
      Messenger.command.execute("change:menu", "reports");
      //set active kb
      if (!this.groupsLoaded) {
        this.show();
        this.showGroups();
        //this.groups.show();
        //          this.groups.groups.once("sync", function() {
        //            this.showHistoricalReport(reportHref);
        //          }, this);
        this.showHistoricalReport(reportHref);
      } //we need to figure out which report to show from the href
      else {
        this.showHistoricalReport(reportHref);
      }

      //        Messenger.command.execute("set:active:kb", kbId);
      //        Messenger.command.execute("change:menu", "topics"); //use same menu icon as topics
      //        var topic = Messenger.reqres.request("topic", intentId); //load topic from server
      //        this.showTopic(topic, intentId);
    },
    _updateReportArguments: function (report, paramsMap) {
      for (let x = 0; x < paramsMap.size; x++) {
        const paramValue = paramsMap.get(report.reportArguments[x].paramUrl);
        if (paramValue.includes("=")) {
          report.reportArguments[x].paramValue = paramValue.substring(paramValue.indexOf("=") + 1);
        } else {
          report.reportArguments[x].paramValue = paramValue;
        }
      }
    },
    _routeReportWithParams: function (kbId, reportHref, splat) {
      const isAuthor = Messenger.reqres.request("user:is:author", kbId);
      const isReporter = Messenger.reqres.request("user:is:reporter", kbId);
      if (!isAuthor && !isReporter) {
        Backbone.history.navigate("", { trigger: true });
        return;
      }
      Messenger.command.execute("set:active:kb", kbId);
      Messenger.command.execute("change:menu", "reports");
      this.showHistoricalReport(reportHref, splat);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "show:reports",
        function () {
          //history
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/reports");

          this.showGroups();
        },
        this,
      );

      Messenger.vent.on(
        "switch:to:report",
        function (report) {
          //history setup
          const kbId = Messenger.reqres.request("active:kb");
          let reportUrl = report.get("href").substring(1);
          const slIndex = reportUrl.indexOf("/");
          if (slIndex !== -1) {
            reportUrl = reportUrl.substring(0, slIndex);
          }
          Backbone.history.navigate(kbId + "/reports/" + reportUrl);

          this.showReport(report, true);
        },
        this,
      );

      Messenger.vent.on(
        "show:adHoc:report",
        function (url) {
          //history
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/reports/adHoc");
          this.showAdHocReport(url);
        },
        this,
      );
    },
    showHistoricalReport: function (reportHref, splat) {
      let c, d;
      const grps = Messenger.reqres.request("report:groups");
      grps.once(
        "sync",
        function () {
          //console.log(JSON.stringify(grps));
          for (c = 0; c < grps.size(); c++) {
            //var group = this.groups.groups[c];
            //Todo: Find a less boilerplatey way to get this.  Surely this can't be the simplest way?
            const group = grps.models[c];
            for (d = 0; d < group.get("reports").models.length; d++) {
              const reportModel = group.get("reports").models[d];
              let reportUrl = reportModel.get("href").substring(1);
              let report = reportModel.toJSON ? reportModel.toJSON() : reportModel;
              const slIndex = reportUrl.indexOf("/");
              if (slIndex !== -1) {
                reportUrl = reportUrl.substring(0, slIndex);
              }
              if (reportUrl === reportHref) {
                console.log("should show this report");
                Messenger.reqres.setHandler(
                  "report:group",
                  function () {
                    return group;
                  },
                  this,
                );

                //handle the splat
                const drillUpReports = [];
                let dIndex = 0;
                if (splat) {
                  const params = splat.split(/[/;]/);
                  const paramsSequence = report.href.split(/[/?&]/);
                  const paramsMap = new Map();
                  let count = 0;
                  for (let x = 0; x < paramsSequence.length; x++) {
                    if (paramsSequence[x].includes("{")) {
                      paramsMap.set(paramsSequence[x], params[count]);
                      count++;
                    }
                  }

                  let argLength = report.reportArguments.length;
                  let hasDrilldown = report.drillDownReport !== null;
                  let additionalLevelDropdown = false;
                  while (params.length > argLength && hasDrilldown) {
                    drillUpReports[dIndex] = report;
                    dIndex++;
                    //set report to its drilldown
                    if (additionalLevelDropdown) {
                      report = report[0];
                      additionalLevelDropdown = false;
                    }
                    report = report.drillDownReport;
                    if (report.toJSON) {
                      report = report.toJSON();
                    }
                    if (report[0] !== undefined) {
                      argLength = report[0].reportArguments.length;
                    }

                    hasDrilldown = report.drillDownReport !== undefined;
                    if (report[0].drillDownReport !== null) {
                      hasDrilldown = true;
                      additionalLevelDropdown = true;
                    }
                  }
                  if (params.length > argLength) {
                    console.log("Warning!  Too many parameters provided for report " + report.name);
                  }
                  drillUpReports[dIndex] = report;
                  dIndex++;

                  //Set the reports to use argument defaults and be from history
                  for (let x = 0; x < drillUpReports.length; x++) {
                    report = drillUpReports[x];
                    if (report instanceof Array) {
                      //multiple drilldowns
                      let y = 0;
                      const reportArray = report;
                      for (y = 0; y < reportArray.length; y++) {
                        reportArray[y].useArgumentDefaults = true;
                        reportArray[y].fromHistory = true;
                        reportArray[y].isVisible = true;
                      }
                    } else {
                      report.useArgumentDefaults = true;
                      report.fromHistory = true;
                      report.isVisible = true;
                    }
                  }

                  //for the top-level report (which corresponds with the config div), set argument values
                  //Then call showReport with it, which will set up the config div correctly
                  if (!this.isOpen) {
                    report = drillUpReports[0];
                    this._updateReportArguments(report, paramsMap);
                    this.showReport(drillUpReports[0], false);
                  }

                  //Now, make sure all parameters are set up for the deepest drilldown (which will ensure all reports
                  // have all parameters), and then display all reports
                  for (let w = 0; w < drillUpReports.length; w++) {
                    //set the report arguments first
                    report = drillUpReports[w];
                    if (report instanceof Array) {
                      //multiple drilldowns
                      this.setUpReportArguments(paramsMap, drillUpReports, report[0]);
                      /**
                       for (y = 0; y < reportArray.length; y++)
                       {
                        report = reportArray[y];

                        if (w === drillUpReports.length - 1)
                        {
                          this.setUpReportArguments(paramsMap, drillUpReports, report);
                        }
                        else
                        {
                          for (var x = 0; x < report.reportArguments.length; x++)
                          {
                            report.reportArguments[x].paramValue = params[x];
                          }
                        }
                      }
                       */
                    } //standard case
                    else {
                      if (w === drillUpReports.length - 1) {
                        this.setUpReportArguments(paramsMap, drillUpReports, report);
                      } else {
                        this._updateReportArguments(report, paramsMap);
                      }
                    }
                  }
                  //set it to use defaults b/c splat values were provided to us
                } else {
                  report.fromHistory = true;
                  this.showReport(reportModel, true);
                }
                return; //exit the loop of report-searching
              }
            }
          }
        },
        this,
      );
    },

    setUpReportArguments: function (paramsMap, drillUpReports, report) {
      //Once the reports are displayed, set fromHistory back to false
      //so that the URL will be updated if the user changes the parameters
      //again
      this._report = report;
      //turn off any previous vents for report finished first
      Messenger.vent.off("report:finished:displaying", null, null);
      //change history status after finishing displaying
      Messenger.vent.on(
        "report:finished:displaying",
        function () {
          for (let x = 0; x < drillUpReports.length; x++) {
            report = drillUpReports[x];
            if (report instanceof Array) {
              //multiple drilldowns
              let y = 0;
              const reportArray = report;
              for (y = 0; y < reportArray.length; y++) {
                reportArray[y].fromHistory = false;
              }
            } else {
              this._report.fromHistory = false;
            }
          }
        },
        this,
      );

      this._updateReportArguments(report, paramsMap);

      //make sure our regions are open so that we can set parameters properly

      if (!this.isOpen) {
        this.showReport(report, false);
      }

      report.useArgumentDefaults = true;
      report.fromHistory = true;
      report.isVisible = true;

      //now make the set:parameter calls

      //Determine if any parameters are needed
      let reportsProcessed = 0;
      let reportsDisplayed = false;
      drillUpReports.forEach(function (drillUpReport) {
        if (_.isArray(drillUpReport)) {
          //This is current functionality and only really currently works because the later drilldowns don't require
          // any extra parameters
          drillUpReport = drillUpReport[0];
        }
        let parametersCollected = 0;
        const parametersNeeded = drillUpReport.reportArguments.length;

        //Set values in config area from the report arguments
        drillUpReport.reportArguments.forEach(function (reportArgument) {
          if (reportArgument.paramType === "Date") {
            reportArgument.paramValue = Messenger.reqres
              .request("to:moment", reportArgument.paramValue)
              .valueOf();
          }

          //For one the param name doesn't match up with the url
          if (
            reportArgument.paramUrl === "{agent}" ||
            reportArgument.paramUrl === "agents={agent}"
          ) {
            var agentNames = ReportUtilities.parseAgentParam(reportArgument.paramValue);
            Messenger.vent.trigger("set:parameter", "selectedAgents", agentNames);
            parametersCollected++;
          } else {
            Messenger.vent.trigger(
              "set:parameter",
              reportArgument.paramUrl.replace("{", "").replace("}", ""),
              reportArgument.paramValue,
            );
            if (reportArgument.paramUrl !== "{topic}" && reportArgument.paramUrl !== "{catVal}") {
              parametersCollected++;
            }
          }

          if (reportArgument.paramUrl === "{topic}") {
            const topic = Messenger.reqres.request("topic", parseInt(reportArgument.paramValue));
            topic.onSynced(function () {
              Messenger.vent.trigger("set:parameter", "selectedTopicName", topic.get("intentName"));
              parametersCollected++;
              if (parametersCollected === parametersNeeded) {
                reportsProcessed++;
                if (reportsProcessed === drillUpReports.length && !reportsDisplayed) {
                  this.displayReport(drillUpReports[0]);
                  reportsDisplayed = true;
                }
              }
            }, this);
          }

          if (reportArgument.paramUrl === "{catVal}") {
            //Need to get the display for the category
            const categories = Messenger.reqres.request("kb:categories");
            categories.onSynced(function () {
              if (categories) {
                categories.forEach(function (category) {
                  category.getValues().forEach(function (value) {
                    if (value.get("categoryValueId") == reportArgument.paramValue) {
                      Messenger.vent.trigger("set:parameter", "catValDisplay", value.get("value"));
                    }
                  });
                });
              }
              parametersCollected++;
              if (parametersNeeded === parametersCollected) {
                reportsProcessed++;
                if (reportsProcessed === drillUpReports.length && !reportsDisplayed) {
                  this.displayReport(drillUpReports[0]);
                  reportsDisplayed = true;
                }
              }
            }, this);
          }
          //The selected trusted sites need to be set now in case the report configuration can't fetch the list of
          // sites in time
          if (reportArgument.paramUrl === "{site}") {
            Messenger.vent.trigger(
              "set:parameter",
              "selectedSites",
              reportArgument.paramValue.split("_"),
            );
          }
        }, this);
        if (parametersNeeded === parametersCollected) {
          reportsProcessed++;
          if (reportsProcessed === drillUpReports.length && !reportsDisplayed) {
            this.displayReport(drillUpReports[0]);
          }
        }
      }, this);
    },
  });

  const Router = Marionette.AppRouter.extend({
    appRoutes: {
      ":kbId/reports": "_routeReports",
      ":kbId/reports/:report": "_routeReportMain",
      ":kbId/reports/:report/*params": "_routeReportWithParams",
    },
  });

  return ReportSplitController;
});
